/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { StyledThumb } from './styles';

function Thumb(props, state) {
  return (
    <StyledThumb {...props} index={state.index}>{state.valueNow}</StyledThumb>
  );
}

export default Thumb;
